module.exports = __webpack_public_path__ + "img/SK.d8e0e96c.svg";